import { type ReactNode } from 'react';
import { Heading, Text, Stack, Box, HStack } from '@chakra-ui/react';
import { ContainerOverlay } from 'components/Container/ContainerOverlay';
import LoaderButton from 'components/Button/LoaderButton';
import { PendingIcon } from 'components/Icons/PendingIcon';

interface AcfFallbackBaseProps {
  heading: ReactNode;
  description?: ReactNode;
  infoText: string;
  onNext: (() => void) | undefined;
  buttonText?: string;
}

export const AcfFallbackBase = ({
  heading,
  description,
  infoText,
  onNext,
  buttonText = 'Next',
}: AcfFallbackBaseProps) => {
  return (
    <ContainerOverlay>
      <Stack p="6" h="full" justify="space-between">
        <Stack px="2" gap="6" py="40px" align="center">
          <PendingIcon />
          <Heading fontWeight="bold" textAlign="center" fontSize="xl">
            {heading}
          </Heading>
          {description && <Text textAlign="center">{description}</Text>}
          <Box bg="gray.100" borderRadius="md" p="4" w="full">
            <HStack align="flex-start" gap="3">
              <Box flexShrink={0} mt="0.5">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 0C3.589 0 0 3.589 0 8C0 12.411 3.589 16 8 16C12.411 16 16 12.411 16 8C16 3.589 12.411 0 8 0ZM8 14.5C4.416 14.5 1.5 11.584 1.5 8C1.5 4.416 4.416 1.5 8 1.5C11.584 1.5 14.5 4.416 14.5 8C14.5 11.584 11.584 14.5 8 14.5Z"
                    fill="#6B7280"
                  />
                  <path
                    d="M7.25 7H8.75V11.5H7.25V7ZM7.25 4.5H8.75V6H7.25V4.5Z"
                    fill="#6B7280"
                  />
                </svg>
              </Box>
              <Text fontSize="sm" color="gray.600">
                {infoText}
              </Text>
            </HStack>
          </Box>
        </Stack>
        <LoaderButton text={buttonText} onClick={onNext} />
      </Stack>
    </ContainerOverlay>
  );
};
